module.exports = __webpack_public_path__ + "img/20191218154536360截图20191218105625428.e19f2c41.jpg";